
  import { createRoot } from "react-dom/client";
  import App from "./app/App.tsx";
  import "./styles/index.css";
  import { initAnalyticsWithConsent } from "./lib/analytics.ts";

  // Production-only trackers (Meta Pixel, Crisp), gated on the visitor's
  // CookieYes consent — nothing non-essential fires before they accept, and
  // they load immediately if/when they do. No-ops in dev / when the IDs aren't
  // configured (see lib/analytics.ts).
  initAnalyticsWithConsent();

  createRoot(document.getElementById("root")!).render(<App />);
  